import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

export const adminLoginData = createSlice({
  name: "Data",
  initialState,
  reducers: {
    setAdminData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAdminData } = adminLoginData.actions;
export default adminLoginData.reducer;
